import { useGoogleLogin, useGoogleOneTapLogin } from "@react-oauth/google";
import { Button } from "react-bootstrap";
import { loginWithGoogleAction } from "../../modules/Login/loginActions";
import { useDispatch } from "react-redux";
import React, { useMemo } from "react";
import BinIcon from "../../components/icon/IconWrapped";
import { LoginGoogleStyled } from "./styled/LoginStyled";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext";

function LoginGoogle(props) {
    const {
        disabled = false,
        isSignUp = false,
    } = props;
    const dispatch = useDispatch();
    const {getLangPath} = useLangContext();

    const btnText = useMemo(() => {
        return isSignUp ? 'sign_up.sign_up_with_google' : 'log_in.log_in_with_google';
    }, [isSignUp]);

    useGoogleOneTapLogin({
        onSuccess: (credentialResponse) => {
            dispatch(loginWithGoogleAction({
                ...credentialResponse,
                sign_up: isSignUp,
            }));
        },
        onError: () => {
            console.log('Login Failed OneTap');
        },
    });

    const loginByGoogleHandler = useGoogleLogin({
        // scope: 'email profile',
        flow: 'auth-code',
        onSuccess: async (tokenResponse) => {
            dispatch(loginWithGoogleAction({
                ...tokenResponse,
                sign_up: isSignUp,
            }));
        },
        onError: errorResponse => console.log(errorResponse),
    });

    return <LoginGoogleStyled>
        <Button variant={'secondary'} onClick={loginByGoogleHandler} className={'w-100'} disabled={disabled}>
            <BinIcon name={'IcGoogle'} size={16}/>{getLangPath(btnText)}</Button>
    </LoginGoogleStyled>
}

export default LoginGoogle;
